import { render, staticRenderFns } from "./IndicadorDiferencaLinha.vue?vue&type=template&id=0110ab63"
import script from "./IndicadorDiferencaLinha.vue?vue&type=script&setup=true&lang=js"
export * from "./IndicadorDiferencaLinha.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports